import React from "react";
import { useParams } from "react-router-dom";
import AppBarMenu from "../../components/AppBarMenu";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import EditPowerCompany from "../../components/management/powerDistributionCompany/Edit";

/**
 * Página dedicada para editar uma concessionária
 * URL: /power-companies/:id (ex: /power-companies/10)
 */
export default function PowerCompanyEditPage() {
  const { id } = useParams();

  return (
    <AppBarMenu>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 3 }}>
          <h1 style={{ margin: 0 }}>Editar Concessionária</h1>
          <p style={{ margin: "8px 0 0 0", color: "text.secondary" }}>
            Gerencie os dados da concessionária
          </p>
        </Box>

        <Paper 
          sx={{ 
            p: 3,
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <EditPowerCompany
            layout="horizontal"
            initialPowerDistributionId={parseInt(id)}
          />
        </Paper>
      </Container>
    </AppBarMenu>
  );
}
